import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { trackApi } from '../services/api';

const LABELS = [
  ['/auction', 'Viewed Auction Store'], ['/news', 'Read News Feed'], ['/directory', 'Browsed Directory'],
  ['/business/manage', 'Managed business listing'], ['/business', 'Viewed a business'], ['/events', 'Viewed Events'],
  ['/blackout', 'Played Blackout Game'], ['/community', 'Visited Community'], ['/leaderboard', 'Viewed Leaderboard'],
  ['/dating', 'Visited Dating'], ['/donate', 'Visited Donate'], ['/profile', 'Viewed Profile'], ['/marketing', 'Used Marketing Suite'],
  ['/plans', 'Viewed Choose a Plan'], ['/admin', 'Used Admin'], ['/', 'Opened Dashboard'],
];
const labelFor = (path) => (LABELS.find(([p]) => (p === '/' ? path === '/' : path.startsWith(p))) || [null, `Visited ${path}`])[1];

const visitorId = () => {
  try {
    let id = localStorage.getItem('pbb_vid');
    if (!id) { id = (crypto.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`); localStorage.setItem('pbb_vid', id); }
    return id;
  } catch { return null; }
};

// Anonymous visitor + member activity tracking for the admin Reports page.
export default function Tracker() {
  const { user, loading } = useAuth();
  const loc = useLocation();
  const lastLabel = useRef(null);

  useEffect(() => {
    if (loading) return;
    if (user) {
      const label = labelFor(loc.pathname);
      if (label === lastLabel.current) return;
      lastLabel.current = label;
      trackApi.ping(label).catch(() => {});
      return;
    }
    const vid = visitorId();
    if (!vid) return;
    const utm = new URLSearchParams(loc.search).get('utm_source') || '';
    trackApi.visit({ visitorId: vid, path: loc.pathname, referrer: document.referrer || '', utmSource: utm }).catch(() => {});
  }, [user, loading, loc.pathname, loc.search]);

  useEffect(() => {
    if (!user?.createdAt) return;
    const fresh = Date.now() - new Date(user.createdAt.endsWith('Z') ? user.createdAt : `${user.createdAt}Z`) < 15 * 60 * 1000;
    const vid = (() => { try { return localStorage.getItem('pbb_vid'); } catch { return null; } })();
    if (fresh && vid) trackApi.visitorSignup(vid).catch(() => {});
  }, [user?.id, user?.createdAt]);

  return null;
}
